import Checkbox from "./Checkbox";
import styled from "styled-components";
import {styles} from "../../Theme/Theme";
import {device} from "../../Theme/breakpoints";

const StyledSwitcherCheckbox = styled.div`
  display: inline-block;
  width: 35px;
  height: 20px;
  border-radius: 15px;
  padding: 0;
  margin: 5px;
  vertical-align: middle;
  background-color: ${({ theme, checked }) => (checked ? theme.colors.success : theme.colors.inputBackground)};
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.1);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out, outline 0s;
  @media (${device.laptopL}) {
    width: 45px;
    height: 25px;
  }
`;

const StyledSwitcherBullet = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 16px;
  height: 16px;
  top: 2px;
  left: 2px;
  border-radius: 50%;
  background-color: ${styles.colors.powderWhite};
  transition: all 0.3s ease-in-out, outline 0s;
  transform: translateX(${({checked}) => (checked ? "15px" : "0")});
  box-shadow: inset 0 0 4px 0 #848484;
  @media (${device.laptopL}) {
    width: 21px;
    height: 21px;
    top: 2px;
    left: 2px;
    transform: translateX(${({checked}) => (checked ? "20px" : "0")});
  }
  svg {
    max-height: 90%;
    max-width: 90%;
  }
`

const StyledLabel = styled.label`
  &:focus-within, &:hover {
    ${StyledSwitcherCheckbox} {
      outline: ${({ theme }) => theme.colors.focusOutline};
    }
  }
`

const SwitcherCheckbox = ({icon, isChecked,...props }) => {
  return (
    <StyledLabel>
      <Checkbox isChecked {...props} />
      <StyledSwitcherCheckbox checked={isChecked}>
        <StyledSwitcherBullet checked={isChecked}>
          {icon}
        </StyledSwitcherBullet>
      </StyledSwitcherCheckbox>
    </StyledLabel>
  );
};

export default SwitcherCheckbox;